<app-auth-navbar></app-auth-navbar>
<div class="container">
    <div class="row">
        <div class="col-lg-4 col-md-6 col-12 mx-auto" style="margin-top: 100px;">
            <div class="d-flex justify-content-center flex-wrap w-100 py-3" *ngIf="offer?.status" >
                <div class="col-12 px-3 text-center py-2 offer" style="background-color: #A0BF81;" [innerHTML]="offer.subject">
                </div>
                <div class="col-10 px-3 text-center mt-2 py-2 offer" style="background-color: #266DD3;" [innerHTML]="offer.message">
                </div>
            </div>
            <form #signInForm="ngForm" (ngSubmit)="onSignIn(signInForm)">
                <h3 class="signin_heading custom-heading text-center">Continue with</h3>
                <br>
                <div class="d-flex justify-content-center align-items-center flex-wrap">
                    <div *ngIf="firebaseService.showAppleSignIn" class="col-12 text-center cursor-pointer my-1" (click)="firebaseService.openAppleSignIn()">
                        <button class="loginBtn loginBtn--apple">
                            Login with Apple
                          </button>
                    </div>
                    <div class="col-12 text-center cursor-pointer my-1" (click)="firebaseService.signInWithGoogle()">
                        <div class="loginBtn loginBtn--google cursor-pointer d-flex align-items-center">
                            Signup with Google
                        </div>
                    </div>
                    <!-- <div class="col-12 text-center cursor-pointer my-1" (click)="firebaseService.signInWithFacebook()">
                        <div class="loginBtn loginBtn--facebook cursor-pointer d-flex align-items-center">
                            Signup with Facebook
                        </div>
                    </div> -->

                    <!-- <div class="col-3 text-center cursor-pointer" data-toggle="tooltip" title="Login with facebook" style="font-size: 32px;" (click)="firebaseService.signInWithFacebook()">
                        <i class="fab fa-facebook-f"></i>
                    </div> -->
                    
                    <!-- <div class="col-3 text-center" style="font-size: 16px;"><i class="fab fa-twitter"></i></div>
                    <div class="col-3 text-center" style="font-size: 16px;"><i class="fab fa-microsoft"></i></div> -->
                </div>
                <br>
                <h5 style="text-align: center; 
                border-bottom: 1px solid rgb(68, 68, 68); 
                line-height: 0.1em;
                margin: 10px 0 20px;">
                    <span style="background:#fff; 
                    padding:0 10px; ">
                        OR
                    </span>
                </h5>
                <div class="text-center my-2">
                    Sign in using email
                </div>
                <div class="form-group">
                    <input #email="ngModel" ngModel name="email" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" type="email" class=" input_figma p-3 w-100" id="exampleInputEmail1" aria-describedby="emailHelp"
                    placeholder="Enter your email address" required>
                </div>
                <p *ngIf="!email.valid && email.dirty" class="text-danger">Please enter a valid email address</p>
                <div class="form-group d-flex align-items-center">
                    <input type="password" ngModel name="password" class="input_figma p-3 w-100" placeholder="Enter your password" required>
                    <i class="far fa-eye cursor-pointer color-blue" style="margin-left:-2rem" (click)="showPassword($event)"></i>
                </div>
                
                
                <div class="text-center my-4" style="line-height: 7px;">
                    <p class="signin__text">By Signing in, you are agreeing to our</p>
                    <a routerLink="/terms-and-conditions" class="terms">Terms & Conditions</a>
                </div>
                <button [disabled]="!signInForm.valid" class="btn primary-btn signin__btn w-100 button_figma">Sign in</button>
                <div class="text-center my-1">
                    <a routerLink="/forget-password" class="forgot__password">Forgot password?</a>
                </div>
                <div class="text-center mt-3">
                    <span class="signin__text">Don't have an account?</span> <span><a [routerLink]="['/register']"  class="terms"> Sign up</a></span>
                </div>
            </form>
            <!-- <p-dialog [(visible)]="firebaseService.get_country_id" [style]="{width : width_modal}" modal="true" [closable]="false" header="Select Country">
            
                
                <div class="d-flex w-100 justify-content-around">
                    <span class="border border-secondary rounded p-2 cursor-pointer align-items-center" (click)="setCountryId(39)" [ngClass]="{'active-country': firebaseService.country_id==39}">
                        
                            Canada
                            <img src="assets/images/cad.png" loading="lazy" width="35" alt="n2xpress - Money Transfer - Canada" class="image-7">
                       
                        
                    </span>
                    <span class="border border-secondary rounded p-2 cursor-pointer align-items-center" (click)="setCountryId(233)" [ngClass]="{'active-country': firebaseService.country_id==233}">
                        
                            USA
                            <img src="assets/images/usd.png" loading="lazy" width="35" alt="n2xpress - Money Transfer USA" class="image-7">
                        
                        
                    </span>
                </div>
                
            </p-dialog> -->
            
        </div>
    </div>
</div>